// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"57b40bec","86":"70790dec","122":"cd780955","126":"39247c45","240":"3fe5589b","316":"5582208a","373":"1c7800b1","378":"bd6e6e04","464":"4fac6002","569":"6fa180b5","733":"2ac8daf6","735":"197980df","793":"e9cbf64f","887":"2bab54ff","918":"4f5902d6"}[chunkId] + ".chunk.js";
};